var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('tooltip-status',[_c('v-icon',{attrs:{"color":_vm.color,"size":"12"}},[_vm._v("lens")]),(_vm.useText)?_c('span',{staticClass:"ml-1",class:_vm.alarmClasses},[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }